// Dependencies
import React, { useEffect, useState, useMemo } from "react";
// Modules
// App
import { apiEndpoints } from "../../config";
import { TextField } from "@mui/material";
import PostEdit from "../../partials/posts/postEdit";

function normalizeUrl(url) {
  if (!url) return url;
  const trimmed = url.trim();
  if (!trimmed) return trimmed;
  // If it already has a protocol, leave it as-is
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  // Otherwise prepend https://
  return `https://${trimmed}`;
}

function isValidUrl(url) {
  if (!url) return true; // empty is fine (not an error)
  try {
    new URL(normalizeUrl(url));
    return true;
  } catch {
    return false;
  }
}

export default function LinkEdit() {
  const [post, setPost] = useState(null);
  const [postLink, setPostLink] = useState(null);
  const [linkError, setLinkError] = useState("");

  useEffect(() => {
    if (post?.field_website) {
      setPostLink(post.field_website);
    }
  }, [post]);

  const handleLinkChange = (e) => {
    const value = e.target.value;
    setPostLink(value);
    if (value && !isValidUrl(value)) {
      setLinkError("Please enter a valid URL (e.g. google.com)");
    } else {
      setLinkError("");
    }
  };

  const handleLinkBlur = () => {
    if (postLink) {
      const normalized = normalizeUrl(postLink);
      setPostLink(normalized);
      // Re-validate after normalization
      if (!isValidUrl(normalized)) {
        setLinkError("Please enter a valid URL (e.g. google.com)");
      } else {
        setLinkError("");
      }
    }
  };

  const extraFields = useMemo(() => {
    const normalizedLink = normalizeUrl(postLink);
    const linkData =
      normalizedLink && !linkError ? { field_website: normalizedLink } : {};
    return { ...linkData };
  }, [postLink, linkError]);

  return (
    <PostEdit
      entityType={"link"}
      apiEndpoint={apiEndpoints.links}
      screenClassName={"links"}
      categoryTitle={"Link category"}
      categoryName={"field_link_category"}
      targetVid={"link_categories"}
      returnRoute={"/links-creator"}
      backBtnText={"Link Library"}
      previewRoute={"/links/preview"}
      logCustomEventType={"Link"}
      extraFields={extraFields}
      editorProps={{ summary: true }}
      disablereactions={true}
      disableComments={true}
      previewOverride={postLink}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
      <TextField
        label="Link URL"
        variant="outlined"
        value={postLink ?? ""}
        onChange={handleLinkChange}
        onBlur={handleLinkBlur}
        size="small"
        error={!!linkError}
        helperText={linkError || "e.g. google.com or https://google.com"}
        placeholder="google.com"
      />
    </PostEdit>
  );
}